// Stub implementation for jsonlint modules to avoid browser compatibility issues
const jsonlintStub = {
  parse: function(text) {
    try {
      return JSON.parse(text);
    } catch (e) {
      throw new Error('JSON parsing error: ' + e.message);
    }
  },
};

export default jsonlintStub;
export const parse = jsonlintStub.parse;
